export default {
      id: "icon-hourglass-usage",
      viewBox: "0 0 15 20",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-hourglass",
      toString: function () {
        return this.url;
      }
    }